/**
 * AI action registry (ported from CliLancers, 2026-08-26) — the bridge that
 * lets the chat drawer read (and, on editor pages, edit) the OPEN page.
 *
 * SECURITY INVARIANT: the assistant operates strictly within the signed-in
 * user's authorization. Providers expose only a compact snapshot of what the
 * page already shows the user (getContext), and any apply(ops) mutates
 * CLIENT-SIDE editor state only — persistence happens exclusively when the
 * user clicks Save, which calls the same REST endpoints with their own JWT,
 * org scope, and role checks. The AI has no server-side write path.
 *
 * A page registers a provider:
 *   { page: 'posts_list',
 *     getContext(): object   — compact snapshot sent with each chat turn,
 *     apply?(ops): string[]  — (editors only) applies ops to live editor
 *                              state, returns human-readable summaries }
 *
 * The drawer asks getAiActions() before each send. Read-only providers omit
 * apply() — the drawer sends their context so the assistant can answer about
 * the visible data, but never applies ops through them. Most-recently
 * registered provider wins (a modal editor over its list page); registration
 * returns an unregister function for unmount.
 */
let stack = [];

export function registerAiActions(provider) {
  stack = [...stack, provider];
  return () => {
    stack = stack.filter((p) => p !== provider);
  };
}

export function getAiActions() {
  return stack.length ? stack[stack.length - 1] : null;
}
